export enum EntityType {
  Bot = 'bot',
  User = 'user',
  System = 'system',
  Guest = 'guest',
  App = 'app',
  Agent = 'agent',
}
